import React                  from 'react';
import FileComponentAlt       from './FileComponentAlt';
import { zipFile as tooltip } from 'pu-data/Tooltips';

const StencilFile = (props) => {
  const { parameters } = props;
  let value = parameters.get ? parameters.get('filename') : parameters.filename;
  const isRequired = value === '' || value === undefined;

  return (
    <div className="form-group">
      <FileComponentAlt
        label="Upload Zip File"
        text="Browse file"
        required={props.required}
        fileName={value || ''}
        isFileRequired={isRequired}
        {...props} />
      <div id="error_gerber_files" />
      {props.children}
    </div>
  );
};

StencilFile.defaultProps = {
  inputClassName: 'ignore-on-quote',
  required      : false,
  tooltip,
};

export default StencilFile;
